import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: "Edit Person",
    ref: "modal",
    size: "xs"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_q_btn, {
        flat: "",
        label: "Cancel",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hide()))
      }),
      _createVNode(_component_async_btn, {
        label: "Save",
        color: "primary",
        task: _ctx.task,
        disabled: !_ctx.canSave,
        onClick: _ctx.save
      }, null, 8, ["task", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_q_input, {
        modelValue: _ctx.label,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.label) = $event)),
        label: "Person Name",
        outlined: "",
        autofocus: "",
        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.canSave && _ctx.save()), ["enter"]))
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 512))
}